// Value mappers
const mapYesNo = (v) => (v === "yes" ? "1" : v === "no" ? "2" : "");
const mapSHG = (v) => (v === "shgs" ? "1" : v === "others" ? "2" : "");
const mapRating = (v) =>
    v === "good" ? "1" : v === "satisfactory" ? "2" : v === "poor" ? "3" : "";
const mapPlates = (v) =>
({
    aluminium_foil_packets: "1",
    single_use_plastic_containers: "2",
    other_materials: "3",
}[v] || "");

// Serialise the payload for console logging
const serialiseForLog = (payload) =>
    Object.fromEntries(
        Object.entries(payload).map(([k, v]) => [
            k,
            v instanceof File ? `[File: ${v.name}]` : v,
        ])
    );

const checkStatus = (...fields) =>
    fields.every(f => f !== "" && f !== null && f !== undefined && (!Array.isArray(f) || f.length > 0))
        ? "complete"
        : "drift";

export const KITCHEN_SECTION_FIELDS = {
    a: [
        "gen_info_A1",
        "gen_info_A1_remark",
        "gen_info_A2",
        "gen_info_A2_remark",
        "gen_info_A3",
        "gen_info_A4",
        "gen_info_A4_to",
        "gen_info_A5",
        "is_gen_info_survey_done",
    ],
    b: [
        "quali_quanti_asment_B1",
        "quali_quanti_asment_B2",
        "quali_quanti_asment_B3",
        "is_quali_quanti_asment_survey_done",
    ],
    c: [
        "water_supply_C1",
        "water_supply_C2",
        "water_supply_C3",
        "water_supply_C3_date",
        "water_supply_C3_upload",
        "water_supply_C4",
        "water_supply_C4_date",
        "water_supply_C4_upload",
        "is_water_supply_survey_done",
    ],
    d: [
        "kitch_spce_D1",
        "kitch_spce_D2",
        "kitch_spce_D3",
        "kitch_spce_D3_upload",
        "kitch_spce_D4",
        "kitch_spce_D5",
        "kitch_spce_D5_upload",
        "kitch_spce_D6",
        "kitch_spce_D6_upload",
        "kitch_spce_D7",
        "kitch_spce_D8",
        "is_kitch_spce_survey_done",
    ],
    e: [
        "sfty_cleans_E1",
        "sfty_cleans_E1_date",
        "sfty_cleans_E1_upload",
        "sfty_cleans_E2",
        "sfty_cleans_E3",
        "is_sfty_cleanl_survey_done",
    ],
    f: [
        "sanitation_F1",
        "sanitation_F2",
        "sanitation_F3",
        "sanitation_F3_upload",
        "sanitation_F4",
        "sanitation_F4_upload",
        "sanitation_F5",
        "sanitation_F6",
        "sanitation_F7",
        "sanitation_F7_upload",
        "sanitation_F8",
        "sanitation_F8_date",
        "sanitation_F8_upload",
        "is_sanitation_survey_done",
    ],
    g: [
        "wst_mngemnt_G1",
        "wst_mngemnt_G2",
        "wst_mngemnt_G2_upload",
        "wst_mngemnt_G3",
        "wst_mngemnt_G3_upload",
        "is_wst_mngemnt_survey_done",
    ],
    h: [
        "pers_hygn_H1",
        "pers_hygn_H1_upload",
        "pers_hygn_H2",
        "pers_hygn_H3",
        "pers_hygn_H3_remark",
        "pers_hygn_H3_upload",
        "pers_hygn_H4",
        "is_pers_hygn_survey_done",
    ],
    i: [
        "food_hygn_I1",
        "food_hygn_I1_remark",
        "is_food_hygn_survey_done",
    ],
    j: [
        "iec_mon_J1",
        "is_iec_mon_survey_done",
    ],
    k: [
        "challenges",
        "suggestions",
    ]
};

export const KITCHEN_COMMON_FIELDS = [
    "reporting_date",
    "kitchen_location_fulladdress",
    "lattitude_longitude",
    "district_id",
    "municipality_id",
    "ward_id",
    "canteens_id",
    "canteen_type_id",
];

export const buildKitchenApiPayload = ({
    answers,
    canteen,
    locationState,
    userLocation,
    reportingDate,
    address,
}) => {
    const a = answers;

    const payload = {
        reporting_date: reportingDate,
        kitchen_location_fulladdress: address || canteen?.kitchen_address || "",
        lattitude_longitude: userLocation
            ? `${userLocation.latitude},${userLocation.longitude}`
            : "",
        district_id: locationState?.districtId || "",
        municipality_id: locationState?.municipalityId || "",
        ward_id: locationState?.wardId || "",
        canteens_id: canteen?.canteen_type || "",
        canteen_type_id: canteen?.id || "",

        gen_info_A1: mapYesNo(a.A1),
        gen_info_A1_remark: a.A1_remark || "",
        gen_info_A2: mapSHG(a.A2),
        gen_info_A2_remark: a.A2_remark || "",
        gen_info_A3: a.A3 || "",
        gen_info_A4: a.A4_from || "",
        gen_info_A4_to: a.A4_to || "",
        gen_info_A5: a.A5 || "",
        is_gen_info_survey_done: checkStatus(a.A1, a.A2, a.A3, a.A4_from, a.A4_to, a.A5),

        quali_quanti_asment_B1: mapRating(a.B1),
        quali_quanti_asment_B2: mapRating(a.B2),
        quali_quanti_asment_B3: mapYesNo(a.B3),
        is_quali_quanti_asment_survey_done: checkStatus(a.B1, a.B2, a.B3),

        water_supply_C1: mapYesNo(a.C1),
        water_supply_C2: mapYesNo(a.C2),
        water_supply_C3: mapYesNo(a.C3),
        water_supply_C3_date: a.C3_date || "",
        water_supply_C3_upload: a.C3_photo || null,
        water_supply_C4: mapYesNo(a.C4),
        water_supply_C4_date: a.C4_date || "",
        water_supply_C4_upload: a.C4_file || null,
        is_water_supply_survey_done: checkStatus(a.C1, a.C2, a.C3, a.C4),

        kitch_spce_D1: mapYesNo(a["D.1"]),
        kitch_spce_D2: mapYesNo(a["D.2"]),
        kitch_spce_D3: mapYesNo(a["D.3"]),
        kitch_spce_D3_upload: a["D.3_photo"] || null,
        kitch_spce_D4: mapYesNo(a["D.4"]),
        kitch_spce_D5: mapYesNo(a["D.5"]),
        kitch_spce_D5_upload: a["D.5_file"] || null,
        kitch_spce_D6: mapYesNo(a["D.6"]),
        kitch_spce_D6_upload: a["D.6_photo"] || null,
        kitch_spce_D7: mapYesNo(a["D.7"]),
        kitch_spce_D8: mapRating(a["D.8"]),
        is_kitch_spce_survey_done: checkStatus(a["D.1"], a["D.2"], a["D.3"], a["D.4"], a["D.5"], a["D.6"], a["D.7"], a["D.8"]),

        sfty_cleans_E1: mapYesNo(a["E.1"]),
        sfty_cleans_E1_date: a["E.1_date"] || "",
        sfty_cleans_E1_upload: a["E.1_photo"] || null,
        sfty_cleans_E2: mapYesNo(a["E.2"]),
        sfty_cleans_E3: mapYesNo(a["E.3"]),
        is_sfty_cleanl_survey_done: checkStatus(a["E.1"], a["E.2"], a["E.3"]),

        sanitation_F1: mapYesNo(a["F.1"]),
        sanitation_F2: mapYesNo(a["F.2"]),
        sanitation_F3: mapYesNo(a["F.3"]),
        sanitation_F3_upload: a["F.3_file"] || null,
        sanitation_F4: mapYesNo(a["F.4"]),
        sanitation_F4_upload: a["F.4_photo"] || null,
        sanitation_F5: mapYesNo(a["F.5"]),
        sanitation_F6: mapYesNo(a["F.6"]),
        sanitation_F7: mapYesNo(a["F.7"]) || null,
        sanitation_F7_upload: a["F.7_photo"] || null,
        sanitation_F8: mapYesNo(a["F.8"]) || null,
        sanitation_F8_date: a["F.8_date"] || "",
        sanitation_F8_upload: a["F.8_photo"] || null,
        is_sanitation_survey_done: checkStatus(a["F.1"], a["F.2"], a["F.3"], a["F.4"], a["F.5"], a["F.6"], a["F.7"], a["F.8"]),

        wst_mngemnt_G1: mapYesNo(a["G.1"]),
        wst_mngemnt_G2: mapYesNo(a["G.2"]),
        wst_mngemnt_G2_upload: a["G.2_photo"] || null,
        wst_mngemnt_G3: mapYesNo(a["G.3"]),
        wst_mngemnt_G3_upload: a["G.3_file"] || null,
        is_wst_mngemnt_survey_done: checkStatus(a["G.1"], a["G.2"], a["G.3"]),

        pers_hygn_H1: mapYesNo(a["H.1"]),
        pers_hygn_H1_upload: a["H.1_photo"] || null,
        pers_hygn_H2: mapYesNo(a["H.2"]),
        pers_hygn_H3: mapYesNo(a["H.3"]),
        pers_hygn_H3_remark: a["H.3_date"] || "",
        pers_hygn_H3_upload: a["H.3_file"] || null,
        pers_hygn_H4: mapYesNo(a["H.4"]),
        is_pers_hygn_survey_done: checkStatus(a["H.1"], a["H.2"], a["H.3"], a["H.4"]),

        food_hygn_I1: mapPlates(a["I.1"]),
        food_hygn_I1_remark: a["I.1_remark"] || "",
        is_food_hygn_survey_done: checkStatus(a["I.1"]),

        iec_mon_J1: mapYesNo(a["J.1"]),
        is_iec_mon_survey_done: checkStatus(a["J.1"]),

        challenges: a["challenges"] || "",
        suggestions: a["suggestions"] || "",

        check_survey_completed: null,
        is_total_survey_complete: null
    };

    return { payload, logPayload: serialiseForLog(payload) };
};

export const parseKitchenApiResponse = (apiData) => {
    const getVal = (key) => apiData[key] !== undefined && apiData[key] !== null ? String(apiData[key]) : "";

    const rYesNo = (v) => v === "1" ? "yes" : v === "2" ? "no" : "";
    const rSHG = (v) => v === "1" ? "shgs" : v === "2" ? "others" : "";
    const rRating = (v) => v === "1" ? "good" : v === "2" ? "satisfactory" : v === "3" ? "poor" : "";
    const rPlates = (v) => v === "1" ? "aluminium_foil_packets" : v === "2" ? "single_use_plastic_containers" : v === "3" ? "other_materials" : "";

    const a = {};

    a.A1 = rYesNo(getVal("gen_info_A1"));
    a.A1_remark = getVal("gen_info_A1_remark");
    a.A2 = rSHG(getVal("gen_info_A2"));
    a.A2_remark = getVal("gen_info_A2_remark");
    a.A3 = getVal("gen_info_A3");
    a.A4_from = getVal("gen_info_A4");
    a.A4_to = getVal("gen_info_A4_to");
    a.A5 = getVal("gen_info_A5");

    a.B1 = rRating(getVal("quali_quanti_asment_B1"));
    a.B2 = rRating(getVal("quali_quanti_asment_B2"));
    a.B3 = rYesNo(getVal("quali_quanti_asment_B3"));

    a.C1 = rYesNo(getVal("water_supply_C1"));
    a.C2 = rYesNo(getVal("water_supply_C2"));
    a.C3 = rYesNo(getVal("water_supply_C3"));
    a.C3_date = getVal("water_supply_C3_date");
    a.C4 = rYesNo(getVal("water_supply_C4"));
    a.C4_date = getVal("water_supply_C4_date");

    a["D.1"] = rYesNo(getVal("kitch_spce_D1"));
    a["D.2"] = rYesNo(getVal("kitch_spce_D2"));
    a["D.3"] = rYesNo(getVal("kitch_spce_D3"));
    a["D.4"] = rYesNo(getVal("kitch_spce_D4"));
    a["D.5"] = rYesNo(getVal("kitch_spce_D5"));
    a["D.6"] = rYesNo(getVal("kitch_spce_D6"));
    a["D.7"] = rYesNo(getVal("kitch_spce_D7"));
    a["D.8"] = rRating(getVal("kitch_spce_D8"));

    a["E.1"] = rYesNo(getVal("sfty_cleans_E1"));
    a["E.1_date"] = getVal("sfty_cleans_E1_date");
    a["E.2"] = rYesNo(getVal("sfty_cleans_E2"));
    a["E.3"] = rYesNo(getVal("sfty_cleans_E3"));

    a["F.1"] = rYesNo(getVal("sanitation_F1"));
    a["F.2"] = rYesNo(getVal("sanitation_F2"));
    a["F.3"] = rYesNo(getVal("sanitation_F3"));
    a["F.4"] = rYesNo(getVal("sanitation_F4"));
    a["F.5"] = rYesNo(getVal("sanitation_F5"));
    a["F.6"] = rYesNo(getVal("sanitation_F6"));
    // Note: the payload mapper maps F.8 OR F.7 to F7. We'll map back to F.7 as a default
    a["F.7"] = rYesNo(getVal("sanitation_F7"));
    a["F.7_photo"] = "";
    a["F.8"] = rYesNo(getVal("sanitation_F8"));
    a["F.8_photo"] = "";

    a["G.1"] = rYesNo(getVal("wst_mngemnt_G1"));
    a["G.2"] = rYesNo(getVal("wst_mngemnt_G2"));
    a["G.3"] = rYesNo(getVal("wst_mngemnt_G3"));

    a["H.1"] = rYesNo(getVal("pers_hygn_H1"));
    a["H.2"] = rYesNo(getVal("pers_hygn_H2"));
    a["H.3"] = rYesNo(getVal("pers_hygn_H3"));
    a["H.3_date"] = getVal("pers_hygn_H3_remark");
    a["H.4"] = rYesNo(getVal("pers_hygn_H4"));

    a["I.1"] = rPlates(getVal("food_hygn_I1"));
    a["I.1_remark"] = getVal("food_hygn_I1_remark");

    a["J.1"] = rYesNo(getVal("iec_mon_J1"));

    a["challenges"] = getVal("challenges");
    a["suggestions"] = getVal("suggestions");

    const completedSections = [];
    if (getVal("is_gen_info_survey_done") === "complete" || checkStatus(a.A1, a.A2, a.A3, a.A4_from, a.A4_to, a.A5) === "complete") completedSections.push("a");
    if (getVal("is_quali_quanti_asment_survey_done") === "complete" || checkStatus(a.B1, a.B2, a.B3) === "complete") completedSections.push("b");
    if (getVal("is_water_supply_survey_done") === "complete" || checkStatus(a.C1, a.C2, a.C3, a.C4) === "complete") completedSections.push("c");
    if (getVal("is_kitch_spce_survey_done") === "complete" || checkStatus(a["D.1"], a["D.2"], a["D.3"], a["D.4"], a["D.5"], a["D.6"], a["D.7"], a["D.8"]) === "complete") completedSections.push("d");
    if (getVal("is_sfty_cleanl_survey_done") === "complete" || checkStatus(a["E.1"], a["E.2"], a["E.3"]) === "complete") completedSections.push("e");
    // For F, we have to handle F.7/F.8 correctly for the checkStatus
    if (getVal("is_sanitation_survey_done") === "complete" || checkStatus(a["F.1"], a["F.2"], a["F.3"], a["F.4"], a["F.5"], a["F.6"], a["F.7"]) === "complete") completedSections.push("f");
    if (getVal("is_wst_mngemnt_survey_done") === "complete" || checkStatus(a["G.1"], a["G.2"], a["G.3"]) === "complete") completedSections.push("g");
    if (getVal("is_pers_hygn_survey_done") === "complete" || checkStatus(a["H.1"], a["H.2"], a["H.3"], a["H.4"]) === "complete") completedSections.push("h");
    if (getVal("is_food_hygn_survey_done") === "complete" || checkStatus(a["I.1"]) === "complete") completedSections.push("i");
    if (getVal("is_iec_mon_survey_done") === "complete" || checkStatus(a["J.1"]) === "complete") completedSections.push("j");
    if (a["challenges"] || a["suggestions"]) completedSections.push("k");

    return { answers: a, completedSections };
};
